module.exports = __webpack_public_path__ + "static/img/season-message-ball.8d1e9dc.png";